var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          ref: "modal",
          on: {
            hidden: function($event) {
              return _vm.$emit("stop-edit")
            }
          }
        },
        [
          _c("h3", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
            _c("i", { staticClass: "fa fa-pencil text-warning" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.resource("SprintPlanning_Edit_EditIssue_DisplayName")
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "modal-body" }, slot: "modal-body" }, [
            _c("div", { staticClass: "row mb-2" }, [
              _vm.hasIssue
                ? _c("div", { staticClass: "col-12 mb-2" }, [
                    _c("label", { attrs: { for: "summary" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "SprintPlanning_Edit_Summary_DisplayName"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      ref: "summary",
                      staticClass: "form-control",
                      attrs: { name: "summary" },
                      domProps: { value: _vm.issue.summary },
                      on: {
                        blur: function($event) {
                          return _vm.changeSummary()
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mb-2" }, [
                _c("div", { staticClass: "row" }, [
                  _vm.hasIssue
                    ? _c(
                        "div",
                        { staticClass: "col-6 mb-2" },
                        [
                          _c("label", { attrs: { for: "assignee" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "SprintPlanning_Edit_AssignedTo_DisplayName"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("dropdown", {
                            attrs: {
                              name: "assignee",
                              datasource: _vm.users,
                              value: _vm.assignee,
                              placeholder: "unassigned",
                              textField: "displayName",
                              valueField: "accountId"
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeUser($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasIssue && _vm.transitions
                    ? _c(
                        "div",
                        { staticClass: "col-6 mb-2" },
                        [
                          _c("label", { attrs: { for: "status" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "SprintPlanning_Edit_Status_DisplayName"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("dropdown", {
                            attrs: {
                              name: "status",
                              datasource: _vm.transitions,
                              value: _vm.status,
                              textField: "name",
                              valueField: "name"
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeStatus($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.hasIssue && _vm.requestedByOptions && _vm.issueHasRequestedBy
                ? _c("div", { staticClass: "col-12 mb-2" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-6 mb-2" },
                        [
                          _c("label", { attrs: { for: "requestedBy" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "SprintPlanning_Issue_RequestedBy_DisplayName"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("dropdown", {
                            attrs: {
                              name: "requestedBy",
                              datasource: _vm.requestedByOptions,
                              value: _vm.requestedBy,
                              placeholder: "-",
                              textField: "value",
                              valueField: "id"
                            },
                            on: { input: _vm.changeRequestedBy }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasIssue
                ? _c("div", { staticClass: "col-6 mb-2" }, [
                    _c("label", { staticClass: "settings-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "SprintPlanning_Edit_Urgency_DisplayName"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "settings-panel" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 mb-2" },
                          [
                            _c("label", { attrs: { for: "priority" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.resource(
                                    "SprintPlanning_Edit_Priority_DisplayName"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("dropdown", {
                              attrs: {
                                name: "priority",
                                datasource: _vm.priorities,
                                value: _vm.priority,
                                textField: "name",
                                valueField: "id"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changePriority($event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasIssue && _vm.weights && _vm.issueHasWeight
                          ? _c(
                              "div",
                              { staticClass: "col-12 mb-2" },
                              [
                                _c("label", { attrs: { for: "weight" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.resource(
                                        "SprintPlanning_Edit_Weight_DisplayName"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("dropdown", {
                                  attrs: {
                                    name: "weight",
                                    datasource: _vm.weights,
                                    value: _vm.weight,
                                    placeholder: "-",
                                    textField: "value",
                                    valueField: "id"
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.changeWeight($event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.canEditTimeTracking
                ? _c("div", { staticClass: "col-6 mb-2" }, [
                    _c("label", { staticClass: "settings-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "SprintPlanning_Edit_TimeTracking_DisplayName"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "settings-panel" }, [
                      _c("div", { staticClass: "row" }, [
                        _vm.hasIssue
                          ? _c(
                              "div",
                              { staticClass: "col-12 mb-2" },
                              [
                                _c("label", { attrs: { for: "estimated" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.resource(
                                        "SprintPlanning_Edit_Estimated_DisplayName"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("jira-time-update", {
                                  attrs: {
                                    name: "estimated",
                                    value: _vm.issue.estimatedSeconds
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.changeEstimate($event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasIssue
                          ? _c(
                              "div",
                              { staticClass: "col-12 mb-2" },
                              [
                                _c("label", { attrs: { for: "remaining" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.resource(
                                        "SprintPlanning_Edit_Remaining_DisplayName"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("jira-time-update", {
                                  attrs: {
                                    name: "remaining",
                                    value: _vm.issue.remainingSeconds
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.changeRemaining($event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.canAddComments
                ? _c(
                    "div",
                    { staticClass: "col-12 mb-2" },
                    [
                      _c("comment", {
                        on: {
                          input: function($event) {
                            return _vm.changeComment($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "modal-footer" }, slot: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.updateIssue()
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(
                  " " + _vm._s(_vm.resource("Button_Save")) + "\n            "
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }